export const returnToMcpClient = (href) => {
	window.location.replace(href);
};
